import Agent, {
  type AgentInstances,
  type AgentParams,
  type AgentSuggestions,
} from '../Agent';

class DiscoveryResearchAgent extends Agent {
  static name = 'Discovery::ResearchAgent';

  static publicName = 'Discovery';

  static available(
    agentParams: AgentParams,
    agentInstances: AgentInstances
  ): boolean {
    if (window.currentAccount?.hasGeneralAiAssistant) {
      // Check if the agent is explicitly enabled by the controller otherwise its disabled by default
      if ((window.availableAgents || []).includes('Discovery::ResearchAgent')) {
        return true;
      }
    }
    return false;
  }

  getSuggestions(): AgentSuggestions {
    return [
      {
        title: 'Summarize',
        prompt:
          'Tell me what you are distilling and how long you want it to be after it is shortened. You can refer to existing Aha! studies and interviews by their ID.',
        prefix: `Here is what I want the AI assistant to do.\n\n-> I am going to ask you to summarize text.\n\nBefore starting though determine if I have told you how I would like you to summarize the text. If not, ask.
Let's start...\n\nThe text is: `,
        icon: 'summarize',
      },
      {
        title: 'Uncover',
        prompt: 'Tell me what types of information you would like to reveal.',
        prefix: `Here is what I want the AI assistant to do.\n\n-> I am going to ask you to uncover insights from text.\n\nBefore starting though determine if I have told you the types of insights I would like you to reveal. If not, ask.
Let's start...\n\nThe text is: `,
        icon: 'whiteboard',
      },
      {
        title: 'Coalesce',
        prompt:
          'Tell me what concepts you want to group to understand the trends.',
        prefix: `Here is what I want the AI assistant to do.\n\n-> I am going to ask you to coalesce information to identify trends from text.\n\nBefore starting though determine if I have told you how I want the information grouped. If not, ask.
Let's start...\n\nThe text is: `,
        icon: 'list',
      },
      {
        title: 'Join',
        prompt:
          'Tell me what information you want to combine with data from interviews or studies.',
        prefix: `Here is what I want the AI assistant to do.\n\n-> I am going to ask you to join additional information to completed interviews or studies.\n\nBefore starting though determine if I have told you how I want the information joined. If not, ask.
Let's start...\n\nThe interviews and studies along with the additional information is: `,
        icon: 'draft',
      },
      {
        title: 'Validate',
        prompt:
          'Tell me what assumptions you want to test to determine if they are true.',
        prefix: `Here is what I want the AI assistant to do.\n\n-> I am going to ask you to test assumptions to help validate if they are true.\n\nBefore starting though determine if I have provided clear assumptions. If not, ask.
Let's start...\n\nThe assumptions are: `,
        icon: 'refine',
      },
    ];
  }
}
Agent.register(DiscoveryResearchAgent);
